import { SpeciesV2 } from '../../interfaces';
import speciesObservationsCyprus from '../../assets/data/DSA_filtered_species_observations_cyprus.csv';
import speciesCyprusPredictions from '../../assets/data/DSA_filtered_species_predictions_cyprus.csv';
import speciesFranceProtected from '../../assets/data/france_protected_data_update.csv';
import franceSpeciesInvasive from '../../assets/data/france_invasive_data_update.csv';
import franceSpeciesRedList from '../../assets/data/france_iucn_red_list.csv';
import franceSpeciesAlien from '../../assets/data/alien_plants_occitanie_biogeo_med.csv'

import spainSpeciesExotic from '../../assets/data/spainSpeciesExotic.csv';
import spainSpeciesInvasive from '../../assets/data/spainSpeciesInvasive.csv';
import spainSpeciesProtected from '../../assets/data/spainSpeciesProtected.csv';
import spainSpeciesThreatend from '../../assets/data/spainSpeciesThreatend.csv';
import Papa from 'papaparse';
import Cookies from 'js-cookie';

export const customCaseStudiesSpecies = async (speciesData: SpeciesV2[], type: string): Promise<SpeciesV2[]> => {
  speciesData = speciesData.filter((species) => species.name !== undefined);

  if (Cookies.get('caseStudy') === 'cyprus') {
    if (type === 'Observations') {
      speciesData = await updateObservationsCyprus(speciesData);
    } else if (type === 'Predictions') {
      speciesData = await updatePredictionsCyprus(speciesData);
    }
  } else if (Cookies.get('caseStudy') === 'pnr_narbonnaise') {
    speciesData = await updateFrance(speciesData);
  } else if (Cookies.get('caseStudy') === 'barcelona') {
    speciesData = await updateSpain(speciesData);
  }
  return speciesData;
};

const parseCsvValue = (value: string | undefined): string | undefined => {
  if (value === 'Yes') return 'True';
  if (value === 'No') return 'False';
  return undefined;
};

const updateObservationsCyprus = (SpeciesList: SpeciesV2[]): Promise<SpeciesV2[]> => {
  return new Promise((resolve) => {
    let updatedList = [...SpeciesList];

    Papa.parse(speciesObservationsCyprus, {
      header: true,
      download: true,
      complete: (results) => {
        if (results.data && Array.isArray(results.data)) {
          const csvData = results.data as any[];
          for (let i = 0; i < updatedList.length; i++) {
            const species = updatedList[i];
            const matchingCsvEntry = csvData.find(
              (csvEntry) =>
                String(csvEntry.tax_id) === String(species.taxaId) && String(csvEntry.id) === String(species.id),
            );
            if (matchingCsvEntry) {
              updatedList[i] = {
                ...species,
                category: matchingCsvEntry.category,
                is_invasive: parseCsvValue(matchingCsvEntry.invasive),
                is_endemic: parseCsvValue(matchingCsvEntry.endemic),
                is_eu_directive: parseCsvValue(matchingCsvEntry.eu_directive),
                is_grin_uses: parseCsvValue(matchingCsvEntry.grin),
                iucn_red_list_category: matchingCsvEntry.red_list,
                native: parseCsvValue(matchingCsvEntry.native),
              };
            }
          }
        }
        resolve(updatedList);
      },
    });
  });
};

const updatePredictionsCyprus = (SpeciesList: SpeciesV2[]): Promise<SpeciesV2[]> => {
  return new Promise((resolve) => {
    let updatedList = [...SpeciesList];

    Papa.parse(speciesCyprusPredictions, {
      header: true,
      download: true,
      complete: (results) => {
        if (results.data && Array.isArray(results.data)) {
          const csvData = results.data as any[];
          for (let i = updatedList.length - 1; i >= 0; i--) {
            const species = updatedList[i];
            const matchingCsvEntry = csvData.find(
              (csvEntry) =>
                String(csvEntry.taxa_id) === String(species.taxaId) && String(csvEntry.id) === String(species.id),
            );
            if (matchingCsvEntry && matchingCsvEntry.delete === 'TRUE') {
              updatedList.splice(i, 1);
            } else if (matchingCsvEntry) {
              updatedList[i] = {
                ...species,
                category: matchingCsvEntry.category,
                is_invasive: parseCsvValue(matchingCsvEntry.invasive),
                is_endemic: parseCsvValue(matchingCsvEntry.endemic),
                is_eu_directive: parseCsvValue(matchingCsvEntry.eu_directive),
                is_grin_uses: parseCsvValue(matchingCsvEntry.grin),
                iucn_red_list_category: matchingCsvEntry.red_list,
                native: parseCsvValue(matchingCsvEntry.native),
              };
            }
          }
        }
        resolve(updatedList);
      },
    });
  });
};

const updateFrance = (SpeciesList: SpeciesV2[]): Promise<SpeciesV2[]> => {
  return new Promise((resolve) => {
    const excludedNames = new Set([
      'Feuille morte',
      'Zz Mousses',
      'ZZ Lichens',
      'Bois',
      'branche morte',
      'Zz Champignons',
      'Cônes',
      'Fruit',
      'rejets mer',
      'Fleurs',
      'Plantule',
      'bois',
      'frruit mort',
      "gousse d'ail",
      'arbuste mort',
      'Lichen',
      'Mousse',
    ]);

    let updatedList = SpeciesList
      .filter((item) => !excludedNames.has((item.name ?? '').trim()))
      .map((item) => ({
        ...item,
        is_protected: 'False',
        category: 'No'
      }));

    Papa.parse(franceSpeciesRedList, {
      header: true,
      download: true,
      complete: (results) => {
        if (results.data && Array.isArray(results.data)) {
          const csvData = results.data as any[];
          const csvMap = new Map<string, any>();

          csvData.forEach(entry => {
            const pnIdKey = (entry.PN_ID ?? '').trim();
            if (pnIdKey) {
              csvMap.set(pnIdKey, entry);
            }
          });

          updatedList.forEach((specie) => {
            const speciesNameKey = (specie.name ?? '').trim();
            if (speciesNameKey) {
              const matchingCsvEntry = csvMap.get(speciesNameKey);
              if (matchingCsvEntry) {
                const redListStatus = matchingCsvEntry.STATUT_UICN;
                if (redListStatus) {
                  specie.france_red_list = redListStatus;
                }
              }
            }
          });
        }
      },
    });
    Papa.parse(franceSpeciesInvasive, {
      header: true,
      download: true,
      complete: (results) => {
        if (results.data && Array.isArray(results.data)) {
          const csvData = results.data as any[];
          const csvMap = new Map<string, any>();
          csvData.forEach(entry => {
            const pnIdKey = (entry.PN_ID ?? '').trim();
            if (pnIdKey) {
              csvMap.set(pnIdKey, entry);
            }
          });
          updatedList.forEach((specie) => {
            const speciesNameKey = (specie.name ?? '').trim();
            const matchingCsvEntry = csvMap.get(speciesNameKey);
            if (matchingCsvEntry) {
              specie.is_invasive = 'True';
            }
          });
        }
      },
    });
    Papa.parse(speciesFranceProtected, {
      header: true,
      download: true,
      complete: (results) => {
        if (results.data && Array.isArray(results.data)) {
          const csvData = results.data as any[];
          const csvMap = new Map<string, any>();
          csvData.forEach(entry => {
            const pnIdKey = (entry.PN_ID ?? '').trim();
            if (pnIdKey) {
              csvMap.set(pnIdKey, entry);
            }
          });
          updatedList.forEach((species, i) => {
            const speciesNameKey = (species.name ?? '').trim();
            const matchingCsvEntry = csvMap.get(speciesNameKey);
            if (matchingCsvEntry) {
              updatedList[i] = {
                ...species,
                is_protected: 'True',
              };
            }
          });
        }
      },
    });
    Papa.parse(franceSpeciesAlien, {
      header: true,
      download: true,
      complete: (results) => {
        if (results.data && Array.isArray(results.data)) {
          const csvData = (results.data as any[]).filter(entry => entry && typeof entry === 'object' && Object.keys(entry as object).length > 0);
          const csvMap = new Map();
          csvData.forEach(entry => {
            const speciesMatchingKey = (entry.PN_ID ?? '').trim();
            if (speciesMatchingKey) {
              csvMap.set(speciesMatchingKey, entry);
            }
          });
          updatedList.forEach((specie) => {
            const speciesNameKey = (specie.name ?? '').trim();
            if (speciesNameKey) {
              const matchingCsvEntry = csvMap.get(speciesNameKey);
              if (matchingCsvEntry) {
                const alienCategory = matchingCsvEntry.CATEGORY;
                if (alienCategory) {
                  specie.alien_plants = alienCategory;
                }
              }
            }
          });
        }
      },
    });
    resolve(updatedList);
  });
};

function updateProtectedStatus(file: string, updatedList: SpeciesV2[], speciesVariable: string): Promise<SpeciesV2[]> {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      download: true,
      complete: (results) => {
        if (results.data && Array.isArray(results.data)) {
          const csvData = results.data as any[];
          for (let i = updatedList.length - 1; i >= 0; i--) {
            const species = updatedList[i];
            const matchingCsvEntry = csvData.find((csvEntry) => String(csvEntry.taxon_id) === String(species.taxaId));
            if (matchingCsvEntry) {
              updatedList[i] = {
                ...species,
                [speciesVariable]: 'True',
              };
            }
          }
          resolve(updatedList);
        } else {
          reject(new Error('Failed to parse CSV data.'));
        }
      },
      error: (err) => reject(err),
    });
  });
}

const updateSpain = (SpeciesList: SpeciesV2[]): Promise<SpeciesV2[]> => {
  return new Promise((resolve) => {
    let updatedList = [...SpeciesList];
    updateProtectedStatus(spainSpeciesExotic, updatedList, 'exotic');
    updateProtectedStatus(spainSpeciesInvasive, updatedList, 'is_invasive');
    updateProtectedStatus(spainSpeciesProtected, updatedList, 'is_protected');
    updateProtectedStatus(spainSpeciesThreatend, updatedList, 'threatened');
    resolve(updatedList);
  });
};
